import * as axios from 'axios';
import { inject } from 'inversify';
import { ServiceTypes } from '../constants/ServiceTypes';
import { ConfigurationService } from './ConfigurationService';

export interface AxiosService {}

export class AxiosServiceFactory {
  @inject(ServiceTypes.ConfigurationService) public ConfigService: ConfigurationService | null = null;

  private configService: ConfigurationService;

  // Instance
  private static apiService: axios.AxiosInstance;

  constructor(configService: ConfigurationService) {
    this.configService = configService;
  }

  async createInstance(type: symbol): Promise<axios.AxiosInstance> {
    const baseUrl = this.configService.getWindowOrigin();

    // return the instance
    switch (type) {
      case ServiceTypes.ApiService:
        return AxiosServiceFactory.apiService || (AxiosServiceFactory.apiService = this.createAxiosInstance(baseUrl, true));
      default:
        throw new Error(`type ${type.toString()} is not found.`);
    }
  }

  private createAxiosInstance(baseUrl: string, withCredentials: boolean): axios.AxiosInstance {
    return axios.default.create({
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      baseURL: baseUrl,
      withCredentials,
    });
  }
}
